// ============================================================================
// Overall Control — filter labels (City / Type / Carrier bar). The stage lists the backend owns.
// ============================================================================

export const DELIVERY_TYPE_LABEL = {
  express: "Express",
  standard: "Standard",
  outstation: "Outstation",
} as const;

// Labels match OMS (src/pages/oms/logistics/board_columns.tsx CARRIER_META).
export const CARRIER_LABEL = {
  own_tms: "Own fleet",
  porter: "Porter",
  delhivery: "Delhivery",
  intercity: "Intercity",
  supplier_managed: "Supplier managed",
} as const;
